module.exports = __webpack_public_path__ + "img/JDB.cbb6fec9.png";